import src from "IMAGE";
export default { src, width: 301, height: 40, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mNITk4O8vf3t4+MjPROSUkJBuHCwsL4zMzMiNra2nQAvUcMH+3haS8AAAAASUVORK5CYII="};
